module.exports = __webpack_public_path__ + "prod/20260124143402/img/shareIcon.d9ffff07.png";